import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import style from './EditPropertyImages.module.css';
import { useParams, useNavigate } from 'react-router-dom';

const EditPropertyImages = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [photos, setPhotos] = useState([]);
  const [newPhotos, setNewPhotos] = useState([]);
  const [photosToRemove, setPhotosToRemove] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const fetchPropertyImages = async () => {
      try {
        const response = await axios.get(`/property/${id}`);
        setPhotos(response.data.data.photo || []);
      } catch (error) {
        console.error('Error al obtener las imágenes:', error);
      }
    };

    fetchPropertyImages();
  }, [id]);

  const handleNewPhotosChange = (e) => {
    const files = Array.from(e.target.files);
    setNewPhotos((prev) => [...prev, ...files]);
  };

  const handleRemovePhoto = (photoUrl) => {
    setPhotosToRemove((prev) => [...prev, photoUrl]);
    setPhotos((prev) => prev.filter((photo) => photo !== photoUrl));
  };

  const handleAddPhotos = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    const formData = new FormData();
    newPhotos.forEach((photo) => {
      formData.append('photo', photo);
    });

    try {
      const response = await axios.put(`/properties/${id}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      alert('Nuevas imágenes agregadas correctamente.');
      window.location.reload();
    } catch (error) {
      console.error('Error al agregar nuevas imágenes:', error);
      alert('Error al agregar nuevas imágenes.');
    } finally {
      setIsLoading(false);
    }
  };

  const handleDeletePhotos = async () => {
    setIsLoading(true);

    try {
      const response = await axios.put(
        `/properties/${id}`,
        {
          photosToRemove,
        },
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );
      alert('Imágenes eliminadas correctamente.');
      setPhotos(response.data.data.photo);
      setPhotosToRemove([]);
    } catch (error) {
      console.error('Error al eliminar imágenes:', error);
      alert('Error al eliminar imágenes.');
    } finally {
      setIsLoading(false);
    }
  };

  const handleReorderSubmit = async () => {
    setIsLoading(true);

    try {
      const response = await axios.put(
        `/properties/${id}`,
        {
          newPhotosOrder: photos,
        },
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );
      alert('Imágenes reordenadas correctamente.');
      setPhotos(response.data.data.photo);
    } catch (error) {
      console.error('Error al reordenar imágenes:', error);
      alert('Error al reordenar imágenes.');
    } finally {
      setIsLoading(false);
    }
  };

  const handleDragEnd = (result) => {
    if (!result.destination) return;

    const reorderedPhotos = Array.from(photos);
    const [removed] = reorderedPhotos.splice(result.source.index, 1);
    reorderedPhotos.splice(result.destination.index, 0, removed);

    setPhotos(reorderedPhotos);
  };

  return (
    <div className={style.container}>
      <h1>Editar Imágenes de la Propiedad</h1>

      <div className={style.instructions}>
        <p>
          Este módulo te permite gestionar las imágenes de la propiedad. Puedes:
        </p>
        <ul>
          <li>Agregar nuevas imágenes seleccionándolas desde tu dispositivo y haciendo clic en "Agregar Imágenes".</li>
          <li>Reordenar las imágenes arrastrándolas y soltándolas, y guardar el nuevo orden con "Guardar Nuevo Orden".</li>
          <li>Eliminar imágenes seleccionándolas con el botón "Eliminar" y confirmando con "Eliminar Imágenes Seleccionadas".</li>
          <li>Volver a la página anterior con el botón "Volver".</li>
        </ul>
      </div>

      <DragDropContext onDragEnd={handleDragEnd}>
  <Droppable droppableId="photos">
    {(provided) => (
      <div
        className={style.imagePreviewContainer}
        {...provided.droppableProps}
        ref={provided.innerRef}
      >
        <h2>Imágenes Actuales</h2>
        {photos.map((photoUrl, index) => (
          <Draggable key={photoUrl} draggableId={photoUrl} index={index}>
            {(provided) => (
              <div
                className={style.imagePreview}
                ref={provided.innerRef}
                {...provided.draggableProps}
                {...provided.dragHandleProps}
              >
                <img src={photoUrl} alt={`Imagen ${index + 1}`} className={style.image} />
                <button
                  type="button"
                  className={style.removeIcon}
                  onClick={() => handleRemovePhoto(photoUrl)}
                >
                  ✕
                </button>
              </div>
            )}
          </Draggable>
        ))}
        {provided.placeholder}
      </div>
    )}
  </Droppable>
</DragDropContext>
      <form onSubmit={handleAddPhotos} className={style.uploadContainer}>
        <h2>Agregar Nuevas Imágenes</h2>
        <input
          type="file"
          multiple
          accept="image/*"
          onChange={handleNewPhotosChange}
        />
        <button type="submit" className={style.submitButton} disabled={isLoading}>
          {isLoading ? 'Guardando...' : 'Agregar Imágenes'}
        </button>
      </form>

      <button
        type="button"
        onClick={handleDeletePhotos}
        className={style.submitButton}
        disabled={isLoading || photosToRemove.length === 0}
      >
        {isLoading ? 'Eliminando...' : 'Eliminar Imágenes Seleccionadas'}
      </button>

      <button
        type="button"
        onClick={handleReorderSubmit}
        className={style.submitButton}
        disabled={isLoading}
      >
        {isLoading ? 'Reordenando...' : 'Guardar Nuevo Orden'}
      </button>

      <button
        type="button"
        className={style.backButton}
        onClick={() => navigate(-1)}
      >
        Volver
      </button>
    </div>
  );
};

export default EditPropertyImages;